import { AuthService } from '@appService/auth.service';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { VssUiBaseNavModel, VssUiNavModel } from '../menu.model';
import { NavigationEnd, Router } from '@angular/router';
import { VssTabDynamicService } from '../../../services/vss-tab-dynamic.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzMessageService } from 'ng-zorro-antd/message';
import { filter } from 'rxjs/operators';
import { NzUploadFile } from 'ng-zorro-antd/upload';

@Component({
  selector: 'vss-ui-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnChanges {

  @Input() contentTpl!: TemplateRef<any>
  @Input() extendStartTpl!: TemplateRef<any>
  @Input() extendEndTpl!: TemplateRef<any>
  /**
   * Template của popup thông tin người dùng hiện tại
   */
  @Input() popoverInfoUserTpl!: TemplateRef<any>
  @Input() logoUrl = '/assets/images/logo/logo.PNG';
  @Input() isCollapsed = false;
  @Input() isHorizontal = false;
  @Input() numberOfAvatar = 2;
  @Input() sizeAvatar = 32;

  @Input() listMenus: VssUiNavModel[] = []
  @Input() set setMenus(v: VssUiBaseNavModel[]) {
    this.listMenus = v.map(m => this.parseMenu(m, 0))
  }
  @Input() username: any = "No Name";
  @Output() onLogout = new EventEmitter<any>();
  @Output() oneChangeExpand = new EventEmitter<any>();


  nzPopoverUserVisible = false;
  textAvatar = '';
  currentUser: any = null;
  loadAvatar = false;

  listMenuFlatten: any[] = [];

  get currentPage(): any {
    return this.tabDynamicService.getCurrentPage().value
  }

  constructor(
    private router: Router,
    private tabDynamicService: VssTabDynamicService,
    private notification: NzNotificationService,
    private message: NzMessageService,
    public authService: AuthService
  ) { }

  ngOnInit() {
    this.flattenMenu();
    this.tabDynamicService.setMenuList(this.listMenuFlatten);
    this.tabDynamicService.setDataTabSelector(this.listMenuFlatten);

    this.router.events.pipe(filter((value: any) => value instanceof NavigationEnd)).subscribe((route: NavigationEnd) => {
      const menu = this.tabDynamicService.getDataRoutes();
      const menuItem = menu.find((t: any) => t.url === route?.urlAfterRedirects || t?.url_pattern?.test(route?.urlAfterRedirects) || t?.urlPattern?.test(route?.urlAfterRedirects));
      this.tabDynamicService.setCurrentPage({ ...menuItem, state: this.router.getCurrentNavigation()?.extras.state, url: route.urlAfterRedirects });
    });
    this.currentUser = this.username;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes?.listMenus?.firstChange) {
      this.flattenMenu()
      this.tabDynamicService.setMenuList(this.listMenuFlatten);
      this.tabDynamicService.setDataTabSelector(this.listMenuFlatten);
      const menuItem = this.tabDynamicService.getDataRoutes()
        .find(x => x.url === this.router.url || x?.url_pattern?.test(this.router.url) || x?.urlPattern?.test(this.router.url));
      this.tabDynamicService.setCurrentPage({ ...menuItem, url: this.router.url });

    }
  }

  clickItem(item: any) {
    if (item.url) {
      if (/^(http:\/\/|https:\/\/|www\.)/g.test(item.url)) {
        window.open(item.url, '_blank')
      } else {
        this.router.navigateByUrl(item.url);
        this.tabDynamicService.setCurrentPage(item);
      }
    }
  }

  flattenMenu(data = this.listMenus) {
    data.forEach((x: any) => {
      if (x.children.length) {
        this.flattenMenu(x.children);
      } else {
        this.listMenuFlatten.push(x);
      }
    });
  }

  parseMenu(data: any, level: number, parent: any = null) {
    let res = {
      id: `${parent?.id ? parent?.id + '-' : ''}${data.id || data.moduleId}`,
      parent: `${parent?.id || ''}`,
      title: data?.moduleName || data?.menuName,
      icon: data.icon || (parent?.id ? '' : 'fa-bars'),
      url: data?.url,
      level: level,
      children: [],
      roles: []
    }
    res.children = (data?.items?.length ? data?.items : data?.menus)?.map((m: any) => this.parseMenu(m, level + 1, res)) || []
    if (data.rules) {
      res.roles = res.roles.concat(Array.isArray(data.rules) ? data.rules : [data.rules])
    }
    if (res.children?.length) {
      res.roles = res.roles.concat(...res.children.map((c: any) => c?.rules || []))
    }
    return res
  }
  expandSidebar() {
    this.isCollapsed = false;
  }

  collapseSidebar() {
    this.isCollapsed = true;
  }
  changeExpand() {
    this.isCollapsed = !this.isCollapsed
    this.oneChangeExpand.emit(this.isCollapsed)
  }
  beforeUpload = (file: NzUploadFile | any): boolean => {
    if (!(/(png|jpg|jpeg){1}/g).test(file.type || '')) {
      this.notification.error('', 'File không đúng định dạng');
      return false;
    }
    if (file.size! > (5 * 1024 * 1024)) {
      this.notification.error('', `Dung lượng ảnh vượt quá 5 MB`);
      return false;
    }
    // call api
    this.loadAvatar = true;
    return false;
  };

  getBase64(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.currentUser.image = reader.result as any || '';
    };
  }
  logout() {
    this.onLogout.emit();
  }

  redirectUserHome() {
    if (!this.authService.isAdministrator())
      this.router.navigateByUrl(`codev/user/organization-membership`)
  }
}
